<template>
  <div class="page_container userListPage">
    <div class="breadcrumb flex-rowl">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item :to="{ path: '/manageCenterIndex/userManagement' }">业务管理</el-breadcrumb-item>
        <el-breadcrumb-item>企业结算信息管理</el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <el-tabs v-model="activeName" @tab-click="handleTab">
      <el-tab-pane
        v-for="(item, index) in countryList"
        :key="index"
        :label="item.tabLabel"
        :name="item.countryid + '_' + item.countryname"
      >
        <el-tabs type="card" v-model="activeName2" @tab-click="handleTab2">
          <el-tab-pane
            v-for="(itemChild, indexChild) in settlementList"
            :key="indexChild"
            :label="itemChild.stypestr"
            :name="itemChild.stype"
          >
            <!-- 注意内容 -->
            <div class="main_container">
              <div
                class="select_add flex-rowl"
                v-if="qySettlementInfoList.length <= 3"
              >
                <p class="flex-rowl" @click="handleShowDialog('')">
                  <i class="iconfont icon-xinzeng"></i> 新增
                </p>
              </div>
              <div class="list_wrap">
                <div
                  class="item_wrap"
                  v-for="(item, index) in qySettlementInfoList"
                  :key="index"
                >
                  <div
                    class="content_wrap flex-between"
                    @click="handleShowDialog(item.id)"
                  >
                    <div class="block flex-rowl" v-if="activeName2 == 1">
                      <p>
                        账户名：<span>{{ item.accountname }}</span>
                      </p>
                      <p>
                        开户银行：<span>{{ item.bankname }}</span>
                      </p>
                      <p>
                        账号：<span>{{ item.account }}</span>
                      </p>
                    </div>
                    <div class="block flex-rowl" v-if="activeName2 == 2">
                      <p>
                        结算工具：<span>{{ item.settoolidstr }}</span>
                      </p>
                      <p>
                        ID：<span>{{ item.cusid }}</span>
                      </p>
                      <p>
                        结算工具账号：<span>{{ item.cusacc }}</span>
                      </p>
                    </div>
                    <div class="editBtn">编辑→</div>
                  </div>
                </div>
              </div>
            </div>
          </el-tab-pane>
        </el-tabs>
      </el-tab-pane>
    </el-tabs>

    <!-- 企业结算信息编辑-银行结算 start -->
    <el-dialog
      title="企业结算信息管理"
      :close-on-click-modal="false"
      :visible.sync="dialogVisible"
      @close="handleCloseDialog('paramsValidateForm')"
    >
      <div class="el-dialog-div">
        <el-form
          :model="paramsValidateForm"
          label-position="top"
          ref="paramsValidateForm"
          :rules="ruleFormDateEdit"
        >
          <el-form-item label="账户名" prop="accountname">
            <el-input
              v-model="paramsValidateForm.accountname"
              placeholder="请输入账户名"
            ></el-input>
          </el-form-item>
          <el-form-item label="开户银行" prop="bankname">
            <el-input
              v-model="paramsValidateForm.bankname"
              placeholder="请输入开户银行"
            ></el-input>
          </el-form-item>
          <el-form-item label="账号" prop="account">
            <el-input
              v-model="paramsValidateForm.account"
              placeholder="请输入账号"
            ></el-input>
          </el-form-item>
          <el-form-item label="结算工具图标" prop="settoolicon">
            <div
              class="upload_box"
              @mouseenter="creenIndex = 2"
              @mouseleave="handleMouseLeave(2)"
            >
              <el-upload
                action
                list-type="picture-card"
                :show-file-list="false"
                :http-request="beforeAvatarUpload"
              >
                <div v-if="paramsValidateForm.settoolicon">
                  <img :src="paramsValidateForm.settoolicon" class="avatar" />
                  <div
                    class="el-upload-list__item-actions flex-rowc"
                    v-show="creenIndex == 2"
                  >
                    <span
                      @click.stop="
                        handlePictureCardPreview(
                          paramsValidateForm.settoolicon
                        )
                      "
                      ><i class="iconfont icon-fangda"></i
                    ></span>
                    <span @click.stop="paramsValidateForm.settoolicon = ''"
                      ><i class="iconfont icon-icon_shanchu-"></i
                    ></span>
                  </div>
                </div>

                <i v-else class="el-icon-plus avatar-uploader-icon"></i>
              </el-upload>
            </div>
          </el-form-item>
        </el-form>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button size="medium" @click="dialogVisible = false"
          >取 消</el-button
        >
        <el-button
          type="primary"
          size="medium"
          :loading="loading"
          @click="submitForm('paramsValidateForm')"
          >{{ !loading ? "确 认" : "提 交 中" }}</el-button
        >
      </div>
    </el-dialog>
    <!-- 企业结算信息编辑-数字支付工具结算 end -->

    <!-- 企业结算信息编辑-数字支付工具结算 start -->
    <el-dialog
      title="企业结算信息管理"
      :close-on-click-modal="false"
      :visible.sync="dialogVisible2"
      @close="handleCloseDialog('paramsValidateForm1')"
    >
      <div class="el-dialog-div">
        <el-form
          :model="paramsValidateForm1"
          label-position="top"
          ref="paramsValidateForm1"
          :rules="ruleFormDateEdit1"
        >
          <el-form-item label="结算工具选择" prop="settoolid">
            <el-radio-group v-model="paramsValidateForm1.settoolid">
              <el-radio
                v-for="(item, index) in settlementToolList"
                :key="index"
                :label="item.id"
                >{{ item.cname }}</el-radio
              >
            </el-radio-group>
          </el-form-item>
          <el-form-item label="结算工具图标" prop="settoolicon">
            <div
              class="upload_box"
              @mouseenter="creenIndex = 1"
              @mouseleave="handleMouseLeave(1)"
            >
              <el-upload
                action
                list-type="picture-card"
                :show-file-list="false"
                :http-request="beforeAvatarUpload"
              >
                <div v-if="paramsValidateForm1.settoolicon">
                  <img :src="paramsValidateForm1.settoolicon" class="avatar" />
                  <div
                    class="el-upload-list__item-actions flex-rowc"
                    v-show="creenIndex == 1"
                  >
                    <span
                      @click.stop="
                        handlePictureCardPreview(
                          paramsValidateForm1.settoolicon
                        )
                      "
                      ><i class="iconfont icon-fangda"></i
                    ></span>
                    <span @click.stop="paramsValidateForm1.settoolicon = ''"
                      ><i class="iconfont icon-icon_shanchu-"></i
                    ></span>
                  </div>
                </div>

                <i v-else class="el-icon-plus avatar-uploader-icon"></i>
              </el-upload>
            </div>
          </el-form-item>
          <el-form-item label="ID" prop="cusid">
            <el-input
              v-model="paramsValidateForm1.cusid"
              placeholder="请输入ID"
            ></el-input>
          </el-form-item>
          <el-form-item label="结算工具账号" prop="cusacc">
            <el-input
              v-model="paramsValidateForm1.cusacc"
              placeholder="请输入结算工具账号"
            ></el-input>
          </el-form-item>
        </el-form>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button size="medium" @click="dialogVisible2 = false"
          >取 消</el-button
        >
        <el-button
          type="primary"
          size="medium"
          :loading="loading"
          @click="submitForm('paramsValidateForm1')"
          >{{ !loading ? "确 认" : "提 交 中" }}</el-button
        >
      </div>
    </el-dialog>
    <!-- 企业结算信息编辑-数字支付工具结算 end -->

    <!-- 放大图片 -->
    <el-dialog :visible.sync="dialogVisible3">
      <img width="100%" height="100%" :src="dialogImageUrl" alt="" />
    </el-dialog>
  </div>
</template>
<script>
import { encryptstringview, getCountry } from "../../api/api";
import {
  getQySettlementList,
  getQySettlementToolList,
  getQySettlementInfoList,
  addQySettlementInfo,
  editQySettlementInfo,
  getQySettlementInfoDetail,
} from "../../api/company";
import { getImageToken, uploadImageOss } from "../../utils/oss";
import { mapState } from "vuex";
export default {
  name: "settlementManagement",
  data() {
    return {
      // 是否提交中
      loading: false,

      // tab国家选中
      activeName: "",
      // 国家列表
      countryList: [],

      // tab结算类型选中
      activeName2: "",
      // 结算类型
      settlementList: [],

      // 结算工具
      settlementToolList: [],

      // 企业结算管理参数
      paramsValidateForm: {
        accountname: "", // 账户名
        bankname: "", // 开户银行
        account: "", // 账号
        settoolicon: "", // 结算工具图标
      },
      ruleFormDateEdit: {
        accountname: [
          {
            required: true,
            message: "请输入账户名",
            trigger: "blur",
          },
        ],
        bankname: [
          {
            required: true,
            message: "请输入开户银行",
            trigger: "blur",
          },
        ],
        account: [
          {
            required: true,
            message: "请输入账号",
            trigger: "blur",
          },
        ],

      },
      paramsValidateForm1: {
        settoolid: "", // 结算工具选择
        settoolicon: "", // 结算工具图标
        cusid: "", // ID 输入支付宝名称
        cusacc: "", // 结算工具账号 输入支付宝账号
      },
      ruleFormDateEdit1: {
        settoolid: [
          { required: true, message: "请选择结算工具选择", trigger: "change" },
        ],
        cusid: [
          {
            required: true,
            message: "请输入ID",
            trigger: "blur",
          },
        ],
        cusacc: [
          {
            required: true,
            message: "请输入结算工具账号",
            trigger: "blur",
          },
        ],
      },

      dialogVisible: false,
      dialogVisible2: false,

      qyid: "", // 企业id
      openid: "", // 用户openid
      id: "", // 企业结算id
      settypeid: "", // 结算类型
      setcountryids: "", // 结算使用区域

      // 企业结算信息
      qySettlementInfoList: [],
      // 企业结算信息详情
      qySettlementInfoDetail: {},

      creenIndex: "",
      dialogImageUrl: "",
      dialogVisible3: false,
    };
  },
  computed: {
    ...mapState(["OPENID"]),
  },
  created() {
    // 获取国家
    this.getCountry();

    // 获取结算工具
    this.getQySettlementToolList();

    let { routerList, OPENID } = this.$store.state;
    let { name } = this.$route;
    // 判断是有有参数需要解密 this.$route中的name和state.routerList对象
    if (name in routerList) {
      if (routerList[name].encryptstring == "") return;
      this.encryptstringview(routerList[name].encryptstring, OPENID);
    }
  },
  methods: {
    // 通过解密获取参数
    async encryptstringview(encryptstring, openid) {
      let res = await encryptstringview({ openid, encryptstring });
      if (res.result) {
        let { qyid } = JSON.parse(res.jsondata);
        this.qyid = qyid;
        this.openid = openid;
      } else {
        this.$router.back();
      }
    },

    // 大图预览
    handlePictureCardPreview(url) {
      this.dialogImageUrl = url;
      this.dialogVisible3 = true;
    },
    // 移除
    handleMouseLeave(creenIndex) {
      let { paramsValidateForm1, paramsValidateForm } = this;
      if (creenIndex == 1 && paramsValidateForm1.settoolicon != "") {
        this.creenIndex = "";
      } else if (creenIndex == 2 && paramsValidateForm.settoolicon!= "") {
        this.creenIndex = "";
      }
    },
    async beforeAvatarUpload(e) {
      let { file } = e;
      const isJPG =
        file.type === "image/jpeg" ||
        file.type === "image/png" ||
        file.type === "image/jpg";
      if (!isJPG) {
        this.$message.error("缩略图只能是图片");
        return;
      }
      const loading = this.$loading({
        lock: true,
        text: "上传中",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)",
      });
      let {creenIndex} = this
      try {
        let { data } = await getImageToken(file.name);

        let { status } = await uploadImageOss(data, file);
        if (status == 200) {
          let url = data.host + "/" + data.key;
          if (creenIndex == 1) {
            this.paramsValidateForm1.settoolicon = url;
          } else if (creenIndex == 2) {
            this.paramsValidateForm.settoolicon = url;
          }
          this.creenIndex = ''
          loading.close();
        } else {
          loading.close();
          this.$message.error("上传失败");
        }
      } catch (error) {
        loading.close();
        // console.error("Upload failed:", error);
      }
    },

    // 获取国家
    getCountry() {
      getCountry().then((res) => {
        res.forEach((element) => {
          // tab命名
          element.tabLabel = element.countryname + "市场结算信息";
        });
        this.activeName = res[0].countryid + "" + "_" + res[0].countryname;
        this.setcountryids = res[0].countryid;
        this.countryList = res;

        // 获取结算类型
        this.getQySettlementList();
      });
    },
    // 获取结算类型
    getQySettlementList() {
      getQySettlementList().then((res) => {
        let newRes = res.list;
        this.settlementList = newRes;
        this.activeName2 = newRes[0].stype;
        this.settypeid = newRes[0].stype;

        // 获取企业结算信息
        this.getQySettlementInfoList();
      });
    },

    // 获取结算工具
    getQySettlementToolList() {
      getQySettlementToolList().then((res) => {
        let newRes = res.list;
        this.settlementToolList = newRes;
      });
    },

    // 获取企业结算信息
    getQySettlementInfoList(isSubmit) {
      let params = {
        pageindex: 1,
        pagesize: 10,
        keyword: "",
        qyid: this.qyid,
        settypeid: this.settypeid, // 结算类型
        setcountryids: this.setcountryids, // 结算使用区域
      };
      getQySettlementInfoList(params).then((res) => {
        this.qySettlementInfoList = res.list;
        if (isSubmit) {
          this.dialogVisible2 = false;
          this.dialogVisible = false;
          this.loading = false;
        }
      });
    },

    // 新增企业结算信息
    addQySettlementInfo(data) {
      let params = {
        qyid: this.qyid,
        openid: this.openid,
        settypeid: this.settypeid, // 结算类型
        setcountryids: this.setcountryids, // 结算使用区域
        ...data,
      };
      addQySettlementInfo(params).then((res) => {
        if (res.result) {
          this.getQySettlementInfoList(true);
        } else {
          this.loading = false;
          this.$message({
            type: "error",
            message: res.message,
          });
        }
      });
    },

    // 编辑企业结算信息
    editQySettlementInfo(data) {
      let params = {
        id: this.id,
        qyid: this.qyid,
        openid: this.openid,
        settypeid: this.settypeid, // 结算类型
        setcountryids: this.setcountryids, // 结算使用区域
        ...data,
      };
      editQySettlementInfo(params).then((res) => {
        if (res.result) {
          this.getQySettlementInfoList(true);
        } else {
          this.loading = false;
          this.$message({
            type: "error",
            message: res.message,
          });
        }
      });
    },

    // 获取企业结算信息详情
    getQySettlementInfoDetail() {
      getQySettlementInfoDetail({ id: this.id }).then((res) => {
        this.qySettlementInfoDetail = res;

        this.paramsValidateForm.accountname = res.accountname
          ? res.accountname
          : "";
        this.paramsValidateForm.bankname = res.bankname ? res.bankname : "";
        this.paramsValidateForm.account = res.account ? res.account : "";
        this.paramsValidateForm.settoolicon = res.settoolicon ? res.settoolicon : ''

        this.paramsValidateForm1.settoolid = res.settoolid ? res.settoolid : "";
        this.paramsValidateForm1.settoolicon = res.settoolicon
          ? res.settoolicon
          : "";
        this.paramsValidateForm1.cusid = res.cusid ? res.cusid : "";
        this.paramsValidateForm1.cusacc = res.cusacc ? res.cusacc : "";
      });
    },

    // 触发tab
    handleTab(tab) {
      this.activeName = tab.name;
      this.setcountryids = tab.name.split("_")[0];
      this.getQySettlementInfoList();
    },
    // 触发tab
    handleTab2(tab) {
      this.activeName2 = tab.name;
      this.settypeid = tab.name;
      this.getQySettlementInfoList();
    },

    handleShowDialog(id) {
      if (this.activeName2 == 1) {
        this.dialogVisible = true;
      } else {
        this.dialogVisible2 = true;
      }
      if (id) {
        this.id = id;
        this.getQySettlementInfoDetail();
      }
    },
    handleCloseDialog(formName) {
      this.$refs[formName].resetFields();
    },
    submitForm(formName) {
      let { id } = this;
      this.loading = true;
      this.$refs[formName].validate((valid) => {
        if (valid) {
          if (this.activeName2 == 1) {
            if (id) {
              this.editQySettlementInfo(this.paramsValidateForm);
            } else {
              this.addQySettlementInfo(this.paramsValidateForm);
            }
          } else {
            if (id) {
              this.editQySettlementInfo(this.paramsValidateForm1);
            } else {
              this.addQySettlementInfo(this.paramsValidateForm1);
            }
          }
        } else {
          this.loading = false;
          console.log("error submit!!");
          return false;
        }
      });
    },
  },
};
</script>
<style lang="less" scoped>
.page_container {
  .main_container {
    .select_add {
      font-size: 18px;
      cursor: pointer;
      .iconfont {
        font-size: 22px;
        color: #6b5e84;
        margin-right: 10px;
      }
    }
    .content_wrap {
      padding: 30px 30px 30px 0;
      cursor: pointer;
      p {
        margin-right: 40px;
      }
      .editBtn {
        font-size: 14px;
        padding: 8px 25px;
        background: #6e5c86;
        border-radius: 45px;
        color: #fff;
        cursor: pointer;
      }
    }
  }
}
</style>